console.log("proforma-tracking ver. 260626b-pixel-bridge");
/**
 * proforma-tracking.js
 * ---------------------------------------------------------------------------
 * Publishes the proforma "completed order" custom event for analytics.
 *
 * IMPORTANT — why this only calls Shopify.analytics.publish() and does NOT push
 * to dataLayer:
 *   GTM is loaded inside the Shopify Web Pixel sandbox (the "GTM Loader" custom
 *   pixel), which runs in a separate JS context with its OWN window/dataLayer.
 *   A window.dataLayer.push() from this storefront page would never reach that
 *   GTM instance. The only bridge across the sandbox boundary is
 *   Shopify.analytics.publish() → analytics.subscribe() inside the custom pixel.
 *   The pixel maps the cart into GA4 ecommerce and pushes the `purchase` /
 *   `proforma_completed` dataLayer events that GTM actually reads.
 *
 *   We pass grandTotalValue so the pixel can report the discounted (invoiced)
 *   total rather than the raw cart.total_price.
 *
 * Loaded via <script> alongside pro-forma-validation-payload.js in the proforma
 * GemPages sections. FormHandler hands an order snapshot to
 * window.ProformaTracking.trackCompleted().
 *
 * Sibling tracking (begin-checkout / email capture / Hyros bridge) lives in
 * pro-forma-hyros-tracking.js. Append ?gar_debug=true to surface logging.
 * ---------------------------------------------------------------------------
 */
(function () {
  const debug = new URLSearchParams(window.location.search).get("gar_debug") === "true";
  const log = (...args) => debug && console.log("📊 proforma-tracking:", ...args);

  /**
   * Publish the proforma completion as a Shopify custom event. The custom pixel
   * (Shopify admin → Customer events) subscribes to "proforma_completed" and is
   * responsible for the GA4 ecommerce mapping + dataLayer `purchase` push.
   *
   * @param {Object} order
   * @param {Object} order.cart            Shopify /cart.js snapshot (taken before cart clear)
   * @param {Object} [order.formData]      Customer form fields
   * @param {number} order.grandTotalValue Invoiced grand total in main currency units (post-discount)
   */
  function trackCompleted(order) {
    if (!order || !order.cart) {
      log("⚠️ trackCompleted called without a cart — skipped");
      return;
    }
    const { cart, formData, grandTotalValue } = order;
    const detail = { cart, formData, grandTotalValue };

    try {
      if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish("proforma_completed", detail);
        log("Shopify.analytics.publish: proforma_completed", detail);
      } else {
        log("⚠️ Shopify.analytics.publish unavailable — proforma_completed not published");
      }
    } catch (err) {
      log("❌ Error publishing proforma_completed:", err);
    }
  }

  window.ProformaTracking = { trackCompleted };
})();
